export default {
    buscando: false,
    paginacao: null,
    items: [],
    selecionado: {},
    usuarios: [],
    tarefas: [],
    todasTarefas: []
}